const Lockout = () => (
  <>
    <h1 className='text-danger'>Konto zablokowane</h1>
    <p className='text-danger'>To konto zostało zablokowane, proszę spróbuj później.</p>
  </>
);

export default Lockout;
